(() => {
  const rootSelector = '[data-strwky-commerce]';
  const toggleSelector = '[data-strwky-theme-toggle]';
  const modes = new Set(['dark', 'light']);

  const getRoot = () => document.querySelector(rootSelector);

  const storageKey = (root) => {
    const themeId = root?.dataset.shopifyThemeId
      || document.documentElement.dataset.shopifyThemeId
      || 'default';
    return `strwky:visual-theme:${window.location.host}:${themeId}`;
  };

  // Volgt de dag/nachtinstelling van het apparaat van de bezoeker.
  const deviceQuery = () => {
    try {
      return window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
    } catch (error) {
      return null;
    }
  };

  const getDefaultMode = (root) => {
    const query = deviceQuery();
    if (query) return query.matches ? 'dark' : 'light';

    // Terugval voor browsers zonder voorkeursinstelling: de stand van het thema.
    const value = root?.dataset.defaultVisualTheme
      || document.documentElement.dataset.strwkyDefaultTheme
      || 'dark';
    return modes.has(value) ? value : 'dark';
  };

  const readStoredMode = (root) => {
    try {
      const value = window.localStorage.getItem(storageKey(root));
      return modes.has(value) ? value : null;
    } catch (error) {
      return null;
    }
  };

  const writeStoredMode = (root, mode) => {
    try {
      window.localStorage.setItem(storageKey(root), mode);
    } catch (error) {
      // De gekozen stand werkt ook zonder opslag.
    }
  };

  const updatePictures = (root, mode) => {
    const sourceKey = mode === 'dark' ? 'srcDark' : 'srcLight';

    root.querySelectorAll('[data-strwky-theme-picture]').forEach((picture) => {
      const source = picture.querySelector('[data-strwky-theme-source]');
      const image = picture.querySelector('[data-strwky-theme-image]');
      const nextSource = source?.dataset[sourceKey];
      const nextImage = image?.dataset[sourceKey];

      if (source && nextSource && source.getAttribute('srcset') !== nextSource) {
        source.setAttribute('srcset', nextSource);
      }
      if (image && nextImage && image.getAttribute('src') !== nextImage) {
        image.setAttribute('src', nextImage);
      }
    });

    root.querySelectorAll('[data-mobile-landscape-dark]').forEach((chapter) => {
      const isLandscape = mode === 'dark'
        ? chapter.dataset.mobileLandscapeDark === 'true'
        : chapter.dataset.mobileLandscapeLight === 'true';
      chapter.classList.toggle('strwky-commerce__chapter--mobile-landscape', isLandscape);
    });
  };

  const updateToggles = (mode) => {
    document.querySelectorAll(toggleSelector).forEach((toggle) => {
      toggle.hidden = false;
      toggle.dataset.theme = mode;
      toggle.setAttribute('aria-checked', String(mode === 'dark'));
      toggle.setAttribute('aria-label', 'Nachtmodus');
      toggle.title = mode === 'dark' ? 'Schakel naar dagmodus' : 'Schakel naar nachtmodus';
    });
  };

  const applyMode = (root, mode, persist = false) => {
    const nextMode = modes.has(mode) ? mode : 'dark';
    if (root) {
      root.classList.remove('strwky-commerce--dark', 'strwky-commerce--light');
      root.classList.add(`strwky-commerce--${nextMode}`);
      root.dataset.visualTheme = nextMode;
      updatePictures(root, nextMode);
    }
    document.documentElement.dataset.strwkyTheme = nextMode;
    updateToggles(nextMode);
    if (persist) writeStoredMode(root, nextMode);
    document.dispatchEvent(new CustomEvent('strwky:theme-change', { detail: { mode: nextMode } }));
  };

  const initialize = () => {
    const root = getRoot();

    if (root?.dataset.themeModeInitialized === 'true') {
      applyMode(root, root.dataset.visualTheme || getDefaultMode(root), false);
      return;
    }

    if (root) root.dataset.themeModeInitialized = 'true';
    applyMode(root, readStoredMode(root) || getDefaultMode(root), false);
  };

  // Wisselt de bezoeker het apparaat van dag naar nacht, dan volgt de site direct mee
  // zolang er nog geen eigen keuze is gemaakt met de schakelaar.
  const query = deviceQuery();
  if (query) {
    const onDeviceChange = () => {
      const root = getRoot();
      if (readStoredMode(root)) return;
      applyMode(root, query.matches ? 'dark' : 'light', false);
    };
    if (query.addEventListener) {
      query.addEventListener('change', onDeviceChange);
    } else if (query.addListener) {
      query.addListener(onDeviceChange);
    }
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(toggleSelector);
    if (!toggle) return;
    const root = getRoot();
    const currentMode = root?.dataset.visualTheme
      || document.documentElement.dataset.strwkyTheme
      || getDefaultMode(root);
    applyMode(root, currentMode === 'dark' ? 'light' : 'dark', true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => window.setTimeout(initialize, 0));
})();
